import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CompanyLicenseService } from 'src/app/configuration/company-license/company-license.service';
import { ZonesDetailComponent } from 'src/app/configuration/zones/zones-detail/zones-detail.component';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { UsersDetailComponent } from '../users-detail/users-detail.component';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {

  @ViewChild("view") public view: ViewComponent;
  public usersFilters: any = {};

  constructor(
    private usersService: UsersService,
    private licensesService: CompanyLicenseService,
    private viewsService: ViewsService,

    private messageService: MessageService,
    private coreDialogService: CoreDialogService,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
  }

  viewUser(user) {
    const ref = this.dialogService.open(UsersDetailComponent, {
      data: {
        id: user ? user.id : 0,
        responsible_id: localStorage.getItem("userId")
      },
      //header: user ? "Detalles del usuario" : "Nuevo usuario",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      this.viewsService.changeView(this.view.code);
      this.view.fireEvent("users.list.results", "reload");
    });
  }

  deleteUser(user) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el usuario " + user.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.usersService.delete(user.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.view.fireEvent("users.list.results", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: () => { }
    });
  }

  onEvent(event: any) {
    if (event.component == "users.list.filters") {
      if (event.event == "action" && event.action.name == "search") this.view.fireEvent("users.list.results", "reload");
    } else if (event.component == "users.list.results") {
      if (event.event == "dblclick") this.viewUser(event.data);
      if (event.event == "action" && event.action.name == "add") this.checkNumUserInLicense();
      if (event.event == "action" && event.action.name == "edit") this.viewUser(event.data);
      if (event.event == "action" && event.action.name == "delete") this.deleteUser(event.data);
    }
  }

  checkNumUserInLicense() {
    this.licensesService.canCreateUser().subscribe(
      data => {
        //Si la company tiene menos users que license.number_of_users...
        if (data) {
          //Permitirá la creación de nuevo usuario:
          this.viewUser(null);
        } else {
          //TODO: Debería mostrarse un popup informando al respecto.
          this.openMessageInPopup();
          //this.messageService.add({ closable: false, severity: 'error', detail: "El número de usuarios supera al permitido en la licencia actual." });
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  openMessageInPopup() {
    this.coreDialogService.notify({
      message: "Se ha alcanzado el número de usuarios permitido en la licencia actual. No puede crear un usuario nuevo, por favor póngase en contacto con el administrador.",
      header: 'Error',
      icon: 'far exclamation-circle',
      color: 'var(--orange-500)',
      accept: () => { }
    });
  }
}
